/**
 * Created by alexey on 28.09.2025
 */

const WoodenUILandmarkSelectWindow = CleverappsWindow.extend({
    onWindowLoaded: function (landmark) {
        this.initialLandmark = landmark;
        this.landmark = landmark;

        this.changeSelectedThrottled = cleverapps.throttle(300, this.createListener(this.changeSelected.bind(this)));
        this.changeBackgroundThrottled = cleverapps.throttle(300, this.createListener(this.changeBackground.bind(this)));

        this._super({
            styles: cleverapps.styles.WoodenUILandmarkSelectWindow.window,
            name: "AchievementWindow",
            closeButton: false,
            noBackground: true,
            content: this.createContent(),
            contentPadding: Map2d.currentMap.isCloseToMapLeft(landmark.unit) ? cleverapps.UI.DOCK_RIGHT : cleverapps.UI.DOCK_LEFT
        });

        this.updateItems();
    },

    onResize: function () {
        this._super();

        if (Map2dScroller.currentScroller) {
            Map2dScroller.currentScroller.scrollToUnit(0, this.landmark.unit, {
                position: cleverapps.UI.DOCK_LEFT | cleverapps.UI.DOCK_RIGHT,
                padding: cleverapps.styles.WoodenUILandmarkSelectWindow.scrollToUnitPadding
            });
        }
    },

    onClose: function () {
        if (this.initialLandmark && this.initialLandmark.stage !== this.landmark.stage) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.LANDMARKS.REPLACE + this.landmark.stage);
        }

        if (Map2d.currentMap) {
            Map2d.currentMap.unhighlightUnit();
        }
    },

    isSelectedLandmark: function (target) {
        return Unit.IsApplicable(target.landmark, this.landmark.unit);
    },

    createContent: function () {
        const bg = this.bg = new cleverapps.Spine(bundles.landmarkselectwindow.jsons.landmark_window_json);
        bg.setAnimation(0, "animation", false);

        this.addScroll(this.createGrid());
        this.createScrollMask();
        this.createTitle();
        this.createHelpButton();
        this.createCloseButton();

        return this.bg;
    },

    createHelpButton: function () {
        const styles = cleverapps.styles.WoodenUILandmarkSelectWindow.helpButton;
        const slot = this.bg.getSlot("slot_help");
        const helpButton = new cleverapps.UI.Button({
            onClicked: function () {
                this.close();

                cleverapps.focusManager.display({
                    focus: "GuideWindow",
                    stack: true,
                    action: function (f) {
                        new GuideWindow(Map2dLocation.currentLocation.landmarks.getGuideWindowOptions());
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }.bind(this),
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            styles
        });

        slot.setLocalZOrder(1);
        slot.addChild(helpButton);
    },

    createCloseButton: function () {
        const styles = cleverapps.styles.WoodenUILandmarkSelectWindow.closeButton;
        const slot = this.bg.getSlot("slot_close");
        const closeButton = new CloseRoundButton({
            onClicked: this.close.bind(this),
            styles
        });

        slot.setLocalZOrder(1);
        slot.addChild(closeButton);
    },

    createTitle: function () {
        const slot = this.bg.getSlot("slot_title");

        const text = cleverapps.UI.generateOnlyText(
            Messages.get("AchievementWindow.title"),
            cleverapps.styles.FONTS.ACHIEVEMENT_TITLE_TEXT
        );
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(slot.width * 0.8, slot.height * 0.9);
        text.setAlignment(slot.width / 2, slot.height / 2);

        slot.setLocalZOrder(1);
        slot.addChild(text);
    },

    createScrollMask: function () {
        const slotMaskTop = this.bg.getSlot("slot_mask_top");
        const slotMaskBottom = this.bg.getSlot("slot_mask_botom");

        const spriteMaskTop = cleverapps.UI.createScale9Sprite(bundles.landmarkselectwindow.frames.landmark_bg_top);
        const spriteMaskBottom = cleverapps.UI.createScale9Sprite(bundles.landmarkselectwindow.frames.landmark_bg_bottom);
        spriteMaskTop.setAlignment(slotMaskTop.width / 2, slotMaskTop.height / 2);
        spriteMaskBottom.setAlignment(slotMaskBottom.width / 2, slotMaskBottom.height / 2);

        spriteMaskTop.setContentSize2(slotMaskTop.width, slotMaskTop.height);
        spriteMaskBottom.setContentSize2(slotMaskBottom.width, slotMaskBottom.height);

        slotMaskTop.setLocalZOrder(1);
        slotMaskBottom.setLocalZOrder(1);

        slotMaskTop.addChild(spriteMaskTop);
        slotMaskBottom.addChild(spriteMaskBottom);
    },

    addScroll: function (content) {
        const slot = this.bg.getSlot("slot_scroll");
        const scroll = this.scroll = new cleverapps.UI.ScrollView(content, {
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });
        scroll.setContentSize(slot.width, slot.height);
        scroll.setAlignment(slot.width / 2, slot.height / 2);
        scroll.setBarPadding(cleverapps.styles.WoodenUILandmarkSelectWindow.scrollBarPadding);
        slot.addChild(scroll);

        if (this.landmark instanceof Landmark) {
            scroll.scrollTo(this.availableUnits.find((unit) => this.isSelectedLandmark(unit)));
        } else {
            scroll.scrollToPercent(100);
        }
    },

    updateItems: function () {
        this.availableUnits.forEach((item) => {
            item.updateState();
        }, this);
    },

    createUnits: function () {
        const availableLandmarks = Map2dLocation.currentLocation.landmarks.listWindowLandmarks(this.initialLandmark);
        return availableLandmarks.map((landmark) => new WoodenUILandmarkSelectItem(landmark));
    },

    createGrid: function () {
        const styles = cleverapps.styles.WoodenUILandmarkSelectWindow.grid;

        this.availableUnits = this.createUnits();

        const grid = this.grid = new cleverapps.GridLayout(this.availableUnits, {
            columns: 3,
            margin: styles.margin,
            padding: styles.padding
        });
        grid.setAlignment(styles.position);

        cleverapps.UI.onClick(grid, this.onClick.bind(this), {
            interactiveScale: false,
            onDoubleClick: cleverapps.config.debugMode && this.onDoubleClick.bind(this)
        });

        const scrollSlot = this.bg.getSlot("slot_scroll");

        const content = new cc.Node();
        const contentHeight = Math.max(grid.height + styles.extraHeight, scrollSlot.height);
        content.setContentSize2(grid.width, contentHeight);
        content.addChild(grid);

        const shelves = this.createShelves();
        content.addChild(shelves);

        return content;
    },

    createShelves: function () {
        const styles = cleverapps.styles.WoodenUILandmarkSelectWindow.shelf;

        const shelfCount = Math.ceil(this.availableUnits.length / 3);
        const actualShelfCount = Math.max(shelfCount, 3);

        const shelves = [];

        for (let i = 0; i < actualShelfCount; i++) {
            const shelf = cleverapps.UI.createScale9Sprite(bundles.landmarkselectwindow.frames.shelf);
            shelf.setContentSize2(styles);
            shelves.push(shelf);
        }

        const layout = new cleverapps.Layout(shelves, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        layout.setAlignment(styles.position);
        layout.setLocalZOrder(-1);

        return layout;
    },

    findClickTarget: function (point) {
        return this.availableUnits.filter((node) => cc.rectContainsPoint(node.getBoundingBox(), point))[0];
    },

    onClick: function (touch) {
        const point = this.grid.convertTouchToNodeSpace(touch);
        const target = this.findClickTarget(point);
        if (target) {
            if (target.canDeploy()) {
                this.changeSelectedThrottled(target);
            } else if (target.canHint()) {
                target.findButtonClick();
            } else if (!this.isSelectedLandmark(target)) {
                this.swapLandmarks(target);
            }
        }
    },

    onDoubleClick: function (touch) {
        const point = this.grid.convertTouchToNodeSpace(touch);
        const target = this.findClickTarget(point);
        if (!target) {
            return;
        }

        const config = AchievementsConfig.findByUnit(target.landmark);
        if (!config) {
            return;
        }

        if (!cleverapps.achievements.isGathered(config.id)) {
            cleverapps.achievements.grant(config.id);
            this.changeSelectedThrottled(target);
            return;
        }

        cleverapps.achievements.revoke(config.id);

        const newChosen = this.availableUnits.find((unit) => unit.canDeploy()) || new WoodenUILandmarkSelectItem({ code: "landmarkspot", stage: 0 });

        if (this.isSelectedLandmark(target)) {
            this.changeSelectedThrottled(newChosen);
        } else if (target.getDeployed()) {
            this.changeBackgroundThrottled(target, newChosen);
        } else {
            this.updateItems();
        }
    },

    swapLandmarks: function (target) {
        this.changeBackgroundThrottled(target, this.landmark);
        this.changeSelectedThrottled(target);
    },

    changeBackground: function (current, newLandmark) {
        const deployLocation = cc.p(current.getDeployed());
        Map2dLocation.currentLocation.landmarks.construct(newLandmark.unit, deployLocation);
        this.updateItems();
    },

    changeSelected: function (target) {
        this.landmark.unit = Map2dLocation.currentLocation.landmarks.construct(target.landmark, cc.p(this.landmark.unit));

        Map2dScroller.currentScroller.scrollToUnit(0.2, this.landmark.unit, {
            position: cleverapps.UI.DOCK_LEFT | cleverapps.UI.DOCK_RIGHT,
            padding: cleverapps.styles.WoodenUILandmarkSelectWindow.scrollToUnitPadding,
            callback: function () {
                Map2d.currentMap.unhighlightUnit(() => {
                    if (!this.closed) {
                        Map2d.currentMap.highlightUnit(this.landmark.unit);
                    }
                });
            }.bind(this)
        });

        this.updateItems();
    },

    onHide: function () {
        this._super();

        Map2d.currentMap.unhighlightUnit();
    },

    listBundles: function () {
        let bundles = ["landmarkselectwindow"];
        const families = {};

        Map2dLocation.currentLocation.landmarks.listWindowLandmarks().forEach((landmark) => {
            families[landmark.code + landmark.stage] = landmark;
        });

        bundles = bundles.concat(Families.listLazyBundles(Object.values(families)));

        return bundles;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ACHIEVEMENT_TITLE_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(160, 65, 53),
            size: 3
        },
        shadow: {
            color: new cc.Color(160, 65, 53),
            direction: cc.size(0, 0),
            size: 2
        }
    }
});

cleverapps.styles.WoodenUILandmarkSelectWindow = {
    sideOffset: 40,

    window: {
        padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10
        }
    },

    grid: {
        width: 900,
        height: 800,

        margin: {
            x: 80,
            y: 160
        },

        padding: {
            x: 15,
            y: 60
        },

        extraHeight: 80,

        position: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -20 }
        }
    },

    helpButton: {
        scale: [0.8, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    },

    closeButton: {
        scale: [0.8, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    },

    scrollBarPadding: {
        sidePadding: 0
    },

    shelf: {
        width: 823,
        height: 111,

        margin: 149,

        position: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -160 }
        }
    },

    scrollToUnitPadding: {
        left: 120,
        right: 120
    }
};
